<template>
  <div>
    <hshead title="套餐列表" bgcolor="#fff"></hshead>
    <div class="product-ul">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="product-li" v-for="(item, index) in tempData" :key="index">
          <div class="left-img">
            <van-image fit="cover" width="2.2rem" height="2.2rem" :src="item.imageUrl" v-if="item.imageUrl"></van-image>
            <van-image fit="cover" width="2.2rem" height="2.2rem" :src="tempImg" v-else></van-image>
          </div>
          <div class="center-p">
            <div class="center-top">
              <div class="img-box">
                <img src="~@/assets/images/product/logo.png" alt />
              </div>
              <div class="this-p">
                {{item.packageName}}
                <span>×{{item.shootValue}}张</span>
              </div>
            </div>
            
            <template v-if="item.priceStatus == 0">
              <div class="center-pri">¥{{item.price}}</div>
              <div class="del-pri">¥{{item.originalPrice}}</div>
            </template>
            <template v-else-if="item.priceStatus == 1">
              <div class="center-pri">配置未生效</div>
            </template>
            <template v-else-if="item.priceStatus == 2">
              <div class="center-pri">配置已过期</div>
            </template>
            
          </div>
          <div class="right-btn-box">
            <!-- <div class="right-btn nobg" v-if="item.status==2" @click="handleProductPriceStatusBatch(item, 1)">上架</div>
            <div class="right-btn nobg" v-else-if="item.status==1" @click="handleProductPriceStatusBatch(item, 2)">下架</div> -->
            <div class="right-btn" @click="handleUpdate(item)">编辑</div>
          </div>
        </div>
      </van-list>
    </div>
        <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span>任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_earnings.active : icon_earnings.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Grapher" icon="manager-o">
        <span>摄影师</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_cameraman.active : icon_cameraman.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Product" icon="orders-o">
        <span>商品管理</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_product.active : icon_product.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Other" icon="apps-o">
        <span>更多</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_more.active : icon_more.inactive
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    
    <!-- 编辑 -->
    <van-dialog
      v-model="dialogUpdateFormVisible"
      class="handle-dialog"
      title="更改套餐信息"
      show-cancel-button
      @confirm="update"
      :beforeClose="beforeClose"
      style="width:100%;height:100%;top:50%;"
    >
    <br>
      <van-cell-group v-if="productPriceConfig">
        <van-field 
          v-model="productPriceConfig.shootValue"
          label="拍摄数量"
          type="number"
        >
        </van-field>
        <van-field 
          v-model="productPriceConfig.originalPrice"
          label="原价"
          type="number"
        >
        </van-field>
        <van-field 
          v-model="productPriceConfig.price"
          label="价格"
          type="number"
        >
        </van-field>
        <van-field
          v-model="productPriceConfig.startDay"
          label="开始时间"
          placeholder="开始时间"
          @click="dateFieldClick('startDay', productPriceConfig.startDay)"
          readonly
        />
        <van-field
          v-model="productPriceConfig.endDay"
          label="结束时间"
          placeholder="结束时间"
          @click="dateFieldClick('endDay', productPriceConfig.endDay)"
          readonly
        />
      </van-cell-group>
    </van-dialog>

    <van-popup v-model="showPopup" :close-on-click-overlay="false" position="bottom">
      <van-datetime-picker
        v-model="curSelectedDate"
        type="date"
        placeholder="日期"
        @confirm="datePickerConfirm"
        @cancel="datePickerCancel"
      />
    </van-popup>

  </div>
</template>

<script>

import hshead from "@/components/common/hshead";
import { Toast, Image, Tabbar, TabbarItem, Dialog, List, CellGroup, Cell, Field, DatetimePicker, Popup } from "vant";
import tempImg from "@/assets/images/product/tempBus.jpg";
import { getProductDetail, updateProductPrice } from "@/api/m/store";
import moment from "moment";
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//摄影师
import cameraman_icon from "@/assets/images/center/nav-3.png";
import cameraman_icon_act from "@/assets/images/center/nav-3-act.png";
//商品管理
import product_icon from "@/assets/images/center/nav-4.png";
import product_icon_act from "@/assets/images/center/nav-4-act.png";
//更多
import more_icon from "@/assets/images/center/nav-5.png";
import more_icon_act from "@/assets/images/center/nav-5-act.png";

export default {
  name: "productList",
  data() {
    return {
      tempImg: tempImg,
      tempData: [],
      active: 3,
      loading: false,
      finished: false,
      //编辑
      dialogUpdateFormVisible: false,
      showPopup: false,
      curSelectedDate: new Date(),
      curClickedField: '',
      productPriceConfig: null,
      icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_cameraman: {
        active: cameraman_icon_act,
        inactive: cameraman_icon,
      },
      icon_product: {
        active: product_icon_act,
        inactive: product_icon,
      },
      icon_more: {
        active: more_icon_act,
        inactive: more_icon,
      },
    };
  },
  methods: {
    onLoad() {
      const { productId } = this.$route.query;
      this.getProductDetail(productId);
    },
    //产品详细信息查询
    getProductDetail(productId) {
      getProductDetail(productId).then(response => {
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getProductDetail -> data', data)
          this.tempData = data
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          this.finished = true;
        }
      })
      .catch(response => {
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    // // 上线、下架
    // handleProductPriceStatusBatch(row, status){
    //   const params = [{
    //     Id: row.id,
    //     Status: status,
    //   }]
    //   this.load(true, '加载中...');
    //   updateProductPriceStatusBatch(params).then((response) => {
    //     this.load(false);
    //     const { code, msg, data } = response;
    //     if (code >= 0) {
    //       this.auditFormVisible = false;
    //       this.tips(`套餐[${status==1?'上架':'下架'}]操作成功`)
    //       var _temp = this.tempData.productPriceConfigs.filter(w => w.id == row.id)[0]
    //       console.info('_temp', _temp)
    //       _temp.status = status
    //     }
    //   }).catch(response => {
    //     this.load(false);
    //     //this.tips(`${response.msg}`);
    //     Toast.fail({duration:1000 * 5, message: `${response.msg}`});
    //   });
    // },
    /************* 编辑相关 *************/ 
    dateFieldClick(field, date) {
      this.showPopup = true
      this.curClickedField = field
      console.info('date', date, moment(date))
      if(date) this.curSelectedDate = new Date(moment(date).format('YYYY-MM-DD'))
    },
    datePickerConfirm(val) {
      this.showPopup = false
      console.info('datePickerConfirm', val, this.curClickedField)
      this.productPriceConfig[this.curClickedField] = moment(val).format('YYYY.MM.DD')
    },
    datePickerCancel() {
      this.showPopup = false
    },
    beforeClose(action, done) {
      if(action == 'cancel') done()
      else done(false)
    },
    handleUpdate(row) {
      this.dialogUpdateFormVisible = true
      this.productPriceConfig = Object.assign({}, row); // copy obj
    },
    update() {
      console.info('update', this.productPriceConfig)
      const {shootValue, price, originalPrice, startDay, endDay} = this.productPriceConfig

      if(shootValue == '') {
        this.tips('拍摄数量输入有误')
        return
      }
      if(price == '') {
        this.tips('价格输入有误')
        return
      }
      if(originalPrice == '') {
        this.tips('原价输入有误')
        return
      }
      if(!startDay || !endDay) {
        this.tips('日期不能为空')
        return
      }

      else {
        this.productPriceConfig.id = this.productPriceConfig.productPriceId
        this.load(true, '加载中...');
        updateProductPrice(this.productPriceConfig).then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`操作成功`);
            this.dialogUpdateFormVisible = false
            for(let i = 0; i < this.tempData.length; i++) {
              if(this.tempData[i].productPriceId == this.productPriceConfig.productPriceId) {
                this.tempData[i] = this.productPriceConfig
              }
            }
          }
        }).catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({duration:1000 * 5, message: `${response.msg}`});
        });
      }
    },
  },
  components: {
    hshead,
    "van-image": Image,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    "van-list": List,
    [Dialog.Component.name]: Dialog.Component,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-field": Field,
    "van-datetime-picker": DatetimePicker,
    "van-popup": Popup,
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.product-ul {
  background-color: #eef2f5;
  padding: 0.25rem (7.5-6.94rem)/2;
  padding-bottom: 1rem;
  .product-li {
    width: 6.94rem;
    height: 2.2rem;
    background-color: #ffffff;
    border-radius: 0.1rem;
    display: flex;
    margin-bottom: 0.25rem;
    .left-img {
      width: 2.2rem;
    }
    .center-p {
      width: 3.37rem;
      padding-left: 0.17rem;
      padding-top: 0.4rem;
      .center-top {
        font-family: PingFang-SC-Bold;
        font-size: 0.3rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.45rem;
        letter-spacing: 0rem;
        color: #333333;
        display: flex;
        .img-box {
          width: 0.32rem;
          height: 0.32rem;
          background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
            linear-gradient(#e2bebf, #e2bebf);
          background-blend-mode: normal, normal;
          border-radius: 50%;
          overflow: hidden;
          margin-top: 0.05rem;
          margin-right: 0.2rem;
          img {
            width: 100%;
          }
        }
        .this-p {
          flex: 1;
          font-family: PingFang-SC-Bold;
          font-size: 0.26rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.45rem;
          letter-spacing: 0rem;
          color: #333333;
          margin-bottom: 0.2rem;
          span {
            color: #999999;
          }
        }
      }
      .center-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.28rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #ff3087;
        padding-left: 0.3rem;
      }
      .del-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.2rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #999;
        text-decoration: line-through;
        padding-left: 0.3rem;
      }
    }
    .right-btn-box {
      flex: 1;
      margin-right: 0.3rem;
      .right-btn {
        width: 1.36rem;
        height: 0.4rem;
        background-color: #00b8f5;
        border-radius: 0.2rem;
        border: solid 1px #00b8f5;
        color: #ffffff;
        font-family: PingFang-SC-Medium;
        font-size: 0.22rem;
        line-height: 0.4rem;
        display: block;
        text-align: center;
        margin-top: 0.5rem;
        &.nobg {
          color: #00b8f5;
          background-color: #fff;
        }
      }
    }
  }
}
.van-dialog__content { padding-top: 10px; }
</style>


// WEBPACK FOOTER //
// src/views/store/priceConfigs.vue